import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const ChainsBroken = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M12.0705524,2.27259339 C12.6040185,2.4155352 12.920601,2.96387216 12.7776591,3.49733826 L9.15419251,17.0202998 C9.0112507,17.5537659 8.46291374,17.8703484 7.92944764,17.7274066 C7.39598154,17.5844648 7.07939905,17.0361278 7.22234086,16.5026617 L10.8458075,2.97970017 C10.9887493,2.44623407 11.5370863,2.12965158 12.0705524,2.27259339 Z M5.97504177,6.00032622 C6.54119967,6.00063054 7,6.45967755 7,7.02583553 C7,7.55417158 6.60026101,7.98914612 6.08672308,8.04480972 L5.97504162,8.05082764 L4.40600522,8.05084746 C3.21893291,8.05084746 2.25662066,8.92540987 2.25662066,10.0042373 C2.25662066,11.0340271 3.13343823,11.8776994 4.24559413,11.9522692 L4.40600522,11.9576271 L4.88101455,11.9576357 C5.49944351,11.9599189 6,12.416241 6,12.9788136 C6,13.5038813 5.56395968,13.9363931 5.00301532,13.993591 L4.88101455,14 L4.40134278,14 C1.97054829,14 0,12.209139 0,10 C0,7.85780461 1.85293062,6.10892112 4.18167139,6.00489531 L4.40134278,6 L5.97504177,6.00032622 Z M15.5986572,6 C18.0294517,6 20,7.790861 20,10 C20,12.209139 18.0294517,14 15.5986572,14 L14.1189855,14 C13.5005565,13.9977082 13,13.5413862 13,12.9788136 C13,12.416241 13.5005565,11.9599189 14.1189855,11.9576357 L15.5939948,11.9576271 C16.7810671,11.9576271 17.7433793,11.0830647 17.7433793,10.0042373 C17.7433793,8.92540987 16.7810671,8.05084746 15.5939948,8.05084746 L15.0249584,8.05082764 C14.458884,8.05080901 14,7.59190987 14,7.02583553 C14,6.45967755 14.4588003,6.00063054 15.0249582,6.00032622 L15.5986572,6 Z"
				id="Shape"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

ChainsBroken.propTypes = {
	color: PropTypes.string,
};

export default ChainsBroken;
